<template>
    <div>
        <preloader/>
        <div id="app" layout="row top-center">
            <div id="container">
                <div class="stretch" ref="container">
                    <div v-if="loaded">
                        <top-bar/>
                        <!--<keep-alive>-->
                        <router-view :key="$route.fullPath"/>
                        <!--</keep-alive>-->
                        <the-footer/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


    import Vue from 'vue'
    import 'normalize.css';
    // import 'animate.css';
    import '@/css/main.scss';
    import 'flex-layout-attribute';

    import TopBar from "@/components/TopBar";
    import TheFooter from "@/components/TheFooter";
    import Settings from '@/AppSettings';
    import Preloader from "@/components/Preloader";


    export default {
        components: {Preloader, TopBar, TheFooter},
        name: 'App',
        data() {
            return {
                loaded: false,
                interval: null,
                stretchValue: 0,
                origin: 0

            }
        },
        created() {
            new Settings().init().then(() => {
                this.loaded = true;
            });
            this.stretchValue = this.$isMobile ? 0.002 : 0.0015;


        },
        mounted() {
            if (!this.$isIE) {
                let pageYOffset = window.pageYOffset;
                let lastSpeed = 1;

                /*if (!this.$isMobile && !this.$isIE && !this.$isSafari) {
                    this.interval = setInterval(() => {

                        const clientHeight = this.$refs.container.clientHeight;
                        const speed = Math.abs(window.pageYOffset - pageYOffset) * this.stretchValue + 1;
                        pageYOffset = window.pageYOffset;
                        this.scale = speed;

                        let origin = (pageYOffset) * 100 / clientHeight;
                        if (pageYOffset + window.innerHeight > clientHeight) {
                            origin = 100;
                        }

                        if (lastSpeed != speed) {
                            TweenMax.to(this.$refs.container, 0.1, {scaleY: speed});
                            TweenMax.to(this, 0.15, {origin: origin});
                            this.$refs.container.style.transformOrigin = `0% ${this.origin}%`;
                            lastSpeed = speed;
                        }

                    }, 33);
                }*/

            }
        },
        destroyed() {
            clearInterval(this.interval);
        }
    }
</script>

<style lang="scss" scoped>

    #app {
        background-color: white;
        min-height: 100vh;
    }

    #container {
        width: 100%;
        height: 100%;
        max-width: 1100px;
        min-width: 320px;
        overflow: hidden;
        width: calc(100vw - 34px);
        /*padding-left: 34px;*/

    }

    .stretch {
        -webkit-backface-visibility: hidden;
        -moz-backface-visibility: hidden;
        backface-visibility: hidden;
        transform: translateZ(0);
        will-change: transform;
        /*position: absolute;*/
        /*top:0;*/
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0.3;
    }
</style>
